// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__YwSDz","title":"Header_title__3zg2F","left":"Header_left__3cYzF","clinicName":"Header_clinicName__GZz5h"};